import {Pipe, PipeTransform} from '@angular/core';
import {CacStateEnum} from '../../services/enums/cac-state.enum';

@Pipe({name: 'cacStatePipe'})
export class CacStatePipe implements PipeTransform {
  transform(value: string, row: any): string {
    let cacStateIcon;
    if (!row.cacProfileId){
      return '';
    }

    if (value === CacStateEnum.BLOCK) {
      cacStateIcon = '<div title="Blocked" class="blocked"><i class="fa fa-times-circle unavailable"></i></div>';
    } else if (value === CacStateEnum.BLOCK_INCOMING) {
      cacStateIcon = '<div title="Blocked Incoming" class="blocked"><i class="fa fa-arrow-right block"' +
        'aria-hidden="true"></i><i class="fa fa-times-circle unavailable"></i></div>';
    } else if (value === CacStateEnum.BLOCK_OUTGOING) {
      cacStateIcon = '<div title="Blocked Outgoing" class="blocked"><i class="fa fa-times-circle unavailable"></i>' +
        '<i class="fa fa-arrow-right block"aria-hidden="true"></i></div>';
    } else {
      cacStateIcon = '<div title="Active"><i class="fa fa-check-circle available"></i></div>';
    }

    return `<div class="center-content">${cacStateIcon}</div>`;
  }
}
